export { default, type ServicesSectionProps } from './ServicesSection';
